module.exports = __webpack_public_path__ + "img/logotype_warex_negative.41ef4f5.png";